import { Component } from "@angular/core";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ModalService } from "../../services/modal/modal.service";
import { Subscription } from "rxjs";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-doc",
  standalone: true,
  imports: [CommonModule, NgxExtendedPdfViewerModule],
  templateUrl: "./doc.component.html",
  styleUrl: "./doc.component.scss",
})
export class DocComponent {
  visible = false;
  pdfSrc = "";
  fileName = "";
  title = "";
  videoVisible = false;
  private subscription: Subscription | undefined;

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.subscription = this.modalService.docModal$.subscribe((state) => {
      this.visible = state.visible;
      this.pdfSrc = state.fileUrl;
      this.fileName = state.fileName;
      this.title = state.title;
      this.videoVisible = this.fileName.includes("Help");
    });
  }

  downloadPDF(): void {
    let link = document.createElement("a");
    link.href = this.pdfSrc;
    link.download = this.fileName; // Provide the download filename.
    link.dispatchEvent(new MouseEvent("click"));
  }

  closeModal(): void {
    this.pdfSrc = "";
    this.videoVisible = false;
    this.modalService.closeDocModal();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
